import './slider-overflow.scss';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { SliderAutoplay, updateActiveTab, startLoaderAnimation, updateLoaderProgress } from '@/js/global.js';
import 'swiper/css';

// Initialize all slider overflow blocks on the page
function initSliderOverflow() {
    const sliderOverflows = document.querySelectorAll('.js-sliderOverflow');
    
    sliderOverflows.forEach((sliderOverflow, blockIndex) => {
        const slider = sliderOverflow.querySelector('.js-slider');
        const navigation = sliderOverflow.querySelector('.js-sliderNav');
        const navItems = navigation.querySelectorAll('li');
        const loaders = sliderOverflow.querySelectorAll('.js-sliderLoader');
        
        if (!slider || !navigation) return;
        
        let currentActiveIndex = 0;
        const totalSlides = navItems.length;
        
        // Create autoplay instance
        const autoplay = new SliderAutoplay();
        
        function handleSlideChange() {
            // Use slideNext() which should work better with centered slides and loop
            swiper.slideNext();
        }
        
        function handleProgress(progressPercent) {
            updateLoaderProgress(loaders[currentActiveIndex], progressPercent);
        }
        
        function startAutoplayForSlide(slideIndex) {
            currentActiveIndex = slideIndex;
            startLoaderAnimation(loaders, slideIndex);
            autoplay.start(slideIndex, totalSlides, handleProgress, handleSlideChange);
        }
        
        // Create Swiper instance with horizontal slide transitions
        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 800,
            allowTouchMove: true, // Enable swipe/touch
            loop: true, // Enable infinite loop
            centeredSlides: true, // Center the active slide
            loopAdditionalSlides: 0, // Reduce extra slides
            loopedSlides: 1, // Only clone one slide on each side
            // Make swiping more sensitive
            touchRatio: 1.5, // Increase touch sensitivity
            resistance: false, // Remove resistance at edges
            threshold: 10, // Lower threshold for slide change (default is 20)
            on: {
                init: function() {
                    // Wait for loop to initialize before setting up
                    setTimeout(() => {
                        updateActiveTab(navItems, 0);
                        startAutoplayForSlide(0);
                    }, 100);
                },
                slideChange: function() {
                    // Use realIndex to get the actual slide position
                    const realIndex = this.realIndex;
                    const activeIndex = this.activeIndex;
                    currentActiveIndex = realIndex;
                    updateActiveTab(navItems, realIndex);
                    startAutoplayForSlide(realIndex);
                },
                touchStart: function() {
                    // Pause autoplay when user starts touching/swiping
                    autoplay.pause();
                },
                touchEnd: function() {
                    // Resume autoplay after user finishes touching/swiping
                    autoplay.resume();
                }
            }
        });
        
        // Add click-to-focus functionality to individual slides
        const slideElements = slider.querySelectorAll('.swiper-slide');
        slideElements.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                // Stop current autoplay
                autoplay.stop();
                
                // Navigate to the clicked slide
                swiper.slideToLoop(index);
                
                // Start autoplay for new slide
                startAutoplayForSlide(index);
            });
        });
        
        // Add click handlers to navigation tabs
        navItems.forEach((navItem, index) => {
            navItem.addEventListener('click', () => {
                // Stop current autoplay
                autoplay.stop();
                
                // Change to the clicked slide using slideToLoop for proper loop handling
                swiper.slideToLoop(index);
                
                // Start autoplay for new slide
                startAutoplayForSlide(index);
            });
        });
        
        // Add manual mouse enter/leave handling for pauseOnMouseEnter
        slider.addEventListener('mouseenter', () => {
            autoplay.pause();
        });
        
        slider.addEventListener('mouseleave', () => {
            autoplay.resume();
        });
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initSliderOverflow);